module.exports = __webpack_public_path__ + "static/media/bg-4.1aae8be7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/web/bg-4.png
// module id = 52
// module chunks = 3